import { Stack, Typography } from "@mui/material";
import React from "react";

const LifeCycleField = ({ value }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      alignContent={"center"}
      height={"100%"}
    >
      <Typography sx={{ marginLeft: "12px" }}>{value || "N/A"}</Typography>
    </Stack>
  );
};

export default LifeCycleField;
